import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

function ScrollIfValidationError({ scrollToElement }) {
  const { submitCount, isValid } = useFormikContext();
  useEffect(() => {
    if (!isValid) {
      const element = document.querySelector(scrollToElement);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [submitCount]); // eslint-disable-line react-hooks/exhaustive-deps
}

ScrollIfValidationError.propTypes = {
  scrollToElement: PropTypes.string.isRequired,
};

export default ScrollIfValidationError;
